import { TranslocoService } from '@jsverse/transloco';
import { getLocaleIdByLanguage, LanguageType } from '../entity/locale';

export class DynamicLocaleId extends String {
  constructor(protected service: TranslocoService) {
    super();
  }

  override toString() {
    return getLocaleIdByLanguage(this.service.getActiveLang() as LanguageType);
  }
}
